import { useState, useEffect } from 'react';

export const WelcomeModal = () => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const firstTimeParam = urlParams.get('first_time');
    if (firstTimeParam === 'true') {
      setIsOpen(true);
      const newUrl = new URL(window.location);
      newUrl.searchParams.delete('first_time');
      window.history.replaceState({}, '', newUrl);
    }
  }, []);

  if (!isOpen) return null;

  return (
    <>
      <div className="modal-overlay" onClick={() => setIsOpen(false)} aria-hidden="true" />
      <div className="modal" role="dialog" aria-modal="true" aria-labelledby="welcome-modal-title">
        <div className="modal-content">
          <h2 id="welcome-modal-title" className="modal-title">Welcome to Slipstream</h2>
          <p className="modal-body">
            Your setup is complete. You can now monitor your integration sync events here.
          </p>
          <button className="btn btn-primary" onClick={() => setIsOpen(false)}>
            Get Started
          </button>
        </div>
      </div>
    </>
  );
};
